// extracted by mini-css-extract-plugin
module.exports = {"callout":"i_Oz","header":"i_O0","icon":"i_O1","description":"i_O2"};